module.exports = __webpack_public_path__ + "img/sub25.e5a69f8d.jpg";